import React, { useState, useEffect } from "react";

import { ThemeProvider } from "styled-components";
import { ToastProvider } from './contexts/ToastContext';
//import { SageSuccessProvider } from './contexts/CheckSageSuccessContext';

import RouteLinks from "./RouteLinks";
import { GlobalStyle } from "./styles/globalStyles"; // Clean version without Kendo conflicts
import { darkTheme, lightTheme } from "./styles/theme";
import '@progress/kendo-theme-fluent/dist/all.css'; // Global Fluent theme
// import './styles/bam.css'; // Material theme - replaced with Fluent
import Login from './pages/Login';

import { userInfoTypes } from "./data/interfaces";
import { AuthContext } from "./contexts/AuthContext";
import dayjs from 'dayjs'
import { jwtDecode } from "jwt-decode";
import { JwtDecoded } from "./types/jwtDecoded.types";

type ThemeContextType = {
    theme: string;
    setTheme: React.Dispatch<React.SetStateAction<string>>;
};
dayjs.locale('en')

const ThemeContext = React.createContext<ThemeContextType | null>(null);

function checkAuthenticationStatus() {
    const token = localStorage.getItem('authToken');

    if (token) {
        // console.log(token)
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Math.floor(Date.now() / 1000);
            if (payload.exp && currentTime < payload.exp) {
                return true;
            }

        } catch (error) {
            // Invalid token format or other error
            console.error('Error checking authentication status:', error);
        }
    }
    return false;
}


const App = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const user: userInfoTypes = checkAuthenticationStatus() === true ? JSON.parse(localStorage.getItem('user') || 'null') : null;
    const [darkMode, setDarkMode] = useState(false);
    const [allowedRoutes, setAllowedRoutes] = useState<string[]>([]);

    console.log("Allowed Routes: ", allowedRoutes);

    useEffect(() => {
        // Check if the user is already logged in, e.g., by checking a token in local/session storage
        const isAuthenticated = checkAuthenticationStatus();
        setLoggedIn(isAuthenticated);
    }, []);

    useEffect(() => {
        if(loggedIn) {    
            if(localStorage.getItem('authToken')){
                const decoded = jwtDecode(localStorage.getItem('authToken') as string) as JwtDecoded
                setAllowedRoutes(decoded["Bamfords.Role"]);
            }
        }
    }, [loggedIn]);

    const [theme, setTheme] = useState("light");
    const themeStyle = theme === "light" ? lightTheme : darkTheme;

    return (
        <AuthContext.Provider value={{ loggedIn, setLoggedIn }}>
            
                <ToastProvider>
                    <ThemeContext.Provider value={{ setTheme, theme }}>
                        <ThemeProvider theme={themeStyle}>
                            <GlobalStyle /> {/* Clean version without Kendo conflicts */}
                            {!loggedIn ? (
                                <Login onLogin={() => { setLoggedIn(true); return true; }} />
                            ) : (
                                <>
                                    <RouteLinks allowedRoutes={allowedRoutes} />
                                </>
                            )}
                        </ThemeProvider>
                    </ThemeContext.Provider>
                </ToastProvider>
            
        </AuthContext.Provider>
    );
};

export default App;
